<template>
    <div>
        <div class="tournament__participation__item">
            <div class="tournament__participation__item__title float-content">
                <p class="item-title fl" :style="{backgroundImage: `url('${require('@/image/icon/icn-filter-06.svg')}')`}">참가자1</p>
                <p class="identification-check fr" :class="!identificationCheck ? 'on' : ''"
                   @click="identificationCheckChangeFunc">본인이 아닌가요?</p>
            </div>

            <!--본인일경우-->
            <div class="form-control-select-wrap" v-if="identificationCheck">
                <div class="form-control-select">
                    <p class="input-title">대표소속</p>
                    <select class="form-control-select" v-model="selectClub" @change="changeSelfNonOpen">
                        <option :value="null">선택해주세요</option>
                        <option :value="org" v-if="orgs" v-for="org in orgs.teamList">{{org.orgName}}</option>
                    </select>
                </div>
                <div class="form-control-select">
                    <p class="input-title">소속</p>
                    <input class="form-control-select" readonly :value="selectClub ? selectClub.orgName : null"
                           placeholder="대표소속을 선택해주세요">
                </div>
                <div class="form-control-select">
                    <p class="input-title">이름</p>
                    <input class="form-control-select" readonly v-model="me.userName">
                </div>

            </div>

            <!--본인이 아닐경우-->
            <div class="form-control-select-wrap" v-else>

                <div class="form-control-select">
                    <p class="input-title">대표소속</p>
                    <select class="form-control-select" v-model="selectClub" @change="changeSelfNonOpen">
                        <option :value="null">선택해주세요</option>
                        <option :value="org" v-if="orgs" v-for="org in orgs.teamList">{{org.orgName}}</option>
                    </select>
                </div>
                <div class="form-control-select">
                    <p class="input-title">소속</p>
                    <input class="form-control-select" readonly :value="selectClub ? selectClub.orgName : null"
                           placeholder="대표소속을 선택해주세요">
                </div>

                <div class="form-control-search-wrap">
                    <p class="input-title">이름</p>
                    <div class="form-control-search">
                        <input class="form-control-select" placeholder="입력해주세요" v-model="nameKeyword"
                               v-on:keyup.enter="searchPlayerFunc()">
                        <span @click="searchPlayerFunc()"/>
                    </div>

                    <div class="name__search__result" v-show="isSearch" v-if="players">
                        <div class="name__search__result__content">
                            <div class="float-content" @click="getPlayer(player)" v-for="player in players.playerList"
                                 :key="player.playerId">
                                <p class="name">{{player.playerName}}</p>
                                <p class="affiliation">{{player.clubName}}({{player.clubId}})</p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>
        <AlertModal v-show="emptyClubAlertShow" content="소속을 먼저 선택해주세요" @close="emptyClubAlertShow=false"></AlertModal>
        <AlertModal v-show="emptyPlayerNameAlertShow" content="검색할 이름을 먼저 입력해주세요"
                    @close="emptyPlayerNameAlertShow=false"></AlertModal>
    </div>
</template>
<script>
    import participantFormMixin from "../../../mixins/participantFormMixin";

    export default {
        mixins: [participantFormMixin],
        data() {
            return {
                userName: null
            }
        },
        created() {
            const _this = this
            this.$store.dispatch('me/getListTnmtUserOrgList', this.$route.params).then((res) => {
                if (res.teamList.length === 1) {
                    _this.selectClub = res.teamList[0]
                    this.$emit('input', {
                        orgId: res.teamList[0].orgId,
                        userId: res.teamList[0].userId,
                        type: 'P'
                    })
                } else {
                    this.$emit('input', {
                        userId: null,
                        type: 'T'
                    })
                }
            })

        },
        methods: {
            identificationCheckChangeFunc() {
                this.identificationCheck = !this.identificationCheck
                if (this.orgs.teamList.length === 1) {
                    if(!this.identificationCheck){
                        this.selectClub = this.orgs.teamList[0]
                        const temp = {
                            orgId: this.orgs.teamList[0].orgId,
                            userId: null,
                            type: 'P'
                        }
                        this.$emit('input', temp)
                    }else{
                        this.selectClub = this.orgs.teamList[0]
                        const temp = {
                            orgId: this.orgs.teamList[0].orgId,
                            userId: this.orgs.teamList[0].userId,
                            type: 'P'
                        }
                        this.$emit('input', temp)
                    }

                } else {
                    const temp = {
                        orgId: null,
                        userId: null,
                        type: 'P'
                    }
                    this.$emit('input', temp)
                }
            },
            changeSelfNonOpen(event) {
                const temp = {
                    orgId: this.slectClub ? this.selectClub.orgId : null,
                    userId: this.selectClub ? this.selectClub.userId : null,
                    type: 'P'
                }
                this.$emit('input', temp)
            },

            searchPlayerFunc() {

                if (!this.selectClub) {
                    this.emptyClubAlertShow = true
                } else if (!this.nameKeyword) {
                    this.emptyPlayerNameAlertShow = true
                } else {
                    const temp = {
                        tnmtId: this.$route.params.tnmtId,
                        clubId: this.selectClub.orgId,
                        playerNameKey: this.nameKeyword
                    }
                    const _this = this
                    this.$store.dispatch('participants/getClubPlayerList', temp).then(res => {
                        _this.isSearch = true
                    })
                }
            },
        }
    }
</script>
